import environment from '@environment';

// NOTE these should not be used going forward... everything should use the CIAM token.
// export const MahApiAuthenticateDomains = [
//   environment.MAH_API_BASE_URL
// ];

// export const MahDStvAfricaApiAuthenticateDomains = [
//   // `${environment.MAH_API_BASE_URL}/${environment.MAH_API_PAYMENT}`,
// ];

export const CEFAuthenticateDomains = [
  environment.MAH_API_BASE_URL,
  environment.UMBRACO_API_URI,
  environment.UTILITY_API_URI,
];

export const FreshDeskAuthenticateDomains = [
  `${environment.FRESHDESK_URL}`,
];